import { useRenderNotifier } from '@wui/common-library'
import { IMFile } from '@wui/im'

import { useLocalization } from '@/shared/composables/localization'
import { tauriMode } from '@/shared/utils/import-meta'
import { getFullURL } from '@/shared/utils/url'

import { downloadFileTauri } from './tauri-download-file'

const downloadFileForWeb = (files: IMFile | IMFile[], pathName?: string) => {
  if (Array.isArray(files)) {
    files.forEach((file) => {
      createLink(file, pathName)
    })
  } else {
    createLink(files, pathName)
  }
}

const createLink = (file: IMFile, pathName?: string) => {
  const link = document.createElement('a')
  const url = pathName ? `${pathName}${file.filecookie}` : file.filecookie
  link.href = getFullURL(url)
  link.download = file.filename
  if (file.filemime) {
    link.type = file.filemime
  }
  link.click()
}
const downloadFileForTauri = (files: IMFile | IMFile[], pathName?: string) => {
  if (Array.isArray(files)) {
    downloadFilesArrayTauri(files)
  } else {
    const file = files
    const { t } = useLocalization()
    const { notifyError, notifySuccess, notifyInfo } = useRenderNotifier()
    downloadFileTauri(file, pathName).then((result) => {
      if (result === null) {
        notifyInfo(t('notifications.fileUploadCancelled'))
      } else {
        notifySuccess(t('notifications.fileUploadedSuccessfully', { name: file.filename }))
      }
    }).catch((e: Error) => {
      notifyError(e.message ?? t('common.unknownError'))
    })
  }
}

const downloadFilesArrayTauri = (files: IMFile[], pathName?: string) => {
  const { t } = useLocalization()
  const { notifyError, notifySuccess, notifyInfo } = useRenderNotifier()
  files.forEach((file) => {
    downloadFileTauri(file, pathName).then((result) => {
      if (result === null) {
        notifyInfo(t('notifications.fileUploadCancelled'))
      } else {
        notifySuccess(t('notifications.fileUploadedSuccessfully', { name: file.filename }))
      }
    }).catch((e: Error) => {
      notifyError(e.message ?? t('common.unknownError'))
    })
  })
}

export const download = (files: IMFile | IMFile[], pathName?: string) => {
  if (tauriMode()) {
    downloadFileForTauri(files, pathName)
  } else {
    downloadFileForWeb(files, pathName)
  }
}
